module.exports = __webpack_public_path__ + "static/img/yeswecan0034.c1ba9e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0034.png
// module id = 600
// module chunks = 1